import { useNavigate } from "react-router-dom";
import { Row, Col, Typography, Divider } from "antd";
import GrammarData from "../data/GrammarData";
import TopicCard from "../components/cards/TopicCard/TopicCard";
import { useDarkMode } from "src/context/DarkModeContext";

const { Title } = Typography;

const Grammar = () => {
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate();

  const handleTopicClick = (route: string) => {
    navigate(route);
  };

  return (
    <div
      id="topics-main-container"
      className={isDarkMode ? "dark" : ""}
      style={{
        padding: "2rem 1rem",
        minHeight: "100vh",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          width: "100%",
        }}
      >
        {Object.keys(GrammarData).map((category) => (
          <section key={category} style={{ marginBottom: "3rem" }}>
            <Title
              level={4}
              style={{
                textAlign: "center",
                marginBottom: "1.25rem",
                fontWeight: 600,
                fontSize: "clamp(18px, 4vw, 20px)",
                lineHeight: 1.3,
                color: isDarkMode ? "#e5e5e5" : "#2a2a2a",
                fontFamily: "'Inter', 'Segoe UI', 'Helvetica Neue', sans-serif",
              }}
            >
              {category}
            </Title>

            <Row gutter={[16, 16]} justify="center">
              {GrammarData[category].map((topic, index) => (
                <Col
                  key={index}
                  xs={24}
                  sm={12}
                  md={8}
                  lg={6}
                  style={{ display: "flex", justifyContent: "center" }} // centers the card inside the column
                >
                  <TopicCard
                    topic={topic}
                    onClick={() => handleTopicClick(topic.route)}
                    className={
                      isDarkMode ? "dark-topic-card" : "light-topic-card"
                    }
                  />
                </Col>
              ))}
            </Row>
            <br />
          </section>
        ))}
      </div>
    </div>
  );
};

export default Grammar;
